import type { FeatureModule } from "@/app";
import { registerMessages } from "@/app";
import { DashboardPage } from "./DashboardPage";

/**
 * Dashboard FeatureModule — the reference implementation of the contract. Copy this shape for a new
 * feature: declare routes + nav + requiredCapabilities, register your i18n in onRegister, export
 * default, then add ONE line to src/app/registry.ts.
 *
 * Dashboard gates on no feature capability (every authenticated user may see it), so
 * requiredCapabilities is empty — ProtectedRoute still requires an authenticated session.
 */
const dashboardModule: FeatureModule = {
  id: "dashboard",
  title: "Tableau de bord",
  requiredCapabilities: [],
  routes: [{ path: "/dashboard", element: <DashboardPage /> }],
  nav: [
    {
      id: "dashboard",
      path: "/dashboard",
      label: "nav.dashboard",
      icon: "▣",
      order: 0,
    },
  ],
  onRegister() {
    registerMessages("fr", {
      "nav.dashboard": "Tableau de bord",
      "dashboard.session.title": "Session",
      "dashboard.session.user": "Utilisateur",
      "dashboard.session.lab": "Laboratoire",
      "dashboard.session.caps": "Capacités effectives",
      "dashboard.launcher.title": "Vos espaces",
      "dashboard.launcher.empty.title": "Aucun espace accessible",
      "dashboard.launcher.empty.desc":
        "Votre profil ne dispose d'aucune capacité d'accès. Contactez votre administrateur.",
    });
    registerMessages("ar", {
      "nav.dashboard": "لوحة القيادة",
      "dashboard.session.title": "الجلسة",
      "dashboard.session.user": "المستخدم",
      "dashboard.session.lab": "المخبر",
      "dashboard.session.caps": "الصلاحيات الفعلية",
      "dashboard.launcher.title": "مساحاتك",
      "dashboard.launcher.empty.title": "لا توجد مساحة متاحة",
      "dashboard.launcher.empty.desc":
        "لا يملك ملفك أي صلاحية وصول. يرجى الاتصال بالمسؤول.",
    });
  },
};

export default dashboardModule;
